/**
 * Copyright (C) 2019 Impulsis <info@impulsis.com>. All rights reserved.
 *
 * All information herein, source code below as well as the Morpheus system itself and all related
 * software (“Items”) are proprietary to Impulsis. Impulsis is the sole copyright owner of the Items.
 * Any use, reproduction, or disclosure of the Items without the written permission of Impulsis
 * is prohibited.
 */

import { GetterTree } from 'vuex'
import { RootState } from '../../types'
import { AuthState } from './types'

export const getters: GetterTree<AuthState, RootState> = {
  accessToken (state): string {
    return state.token
  },
  jwtIatTimestamp (state): number {
    return state.jwtIatTimestamp
  },
  jwtExpTimestamp (state): number {
    return state.jwtExpTimestamp
  },
  admin (state): any {
    return state.admin
  }
}
